import * as React from "react";
import { Truck } from "../../../types";
import { StatCards } from "../StatCards";
import VehicleTable from "../../tables/VehicleTable/VehicleTable";
import { NoEntries } from "./NoEntries";

interface YardTabContentProps {
  trucks: Truck[];
  token?: string;
  deleteTruck: (truck: Truck) => void;
  updateTruck: (truck: Truck) => void;
  updateEntryDirection: (truck: Truck, direction: "in" | "out") => void;
  updateLicensePlate: (truck: Truck, newLicensePlate: string) => void;
  availabilityFilter: "all" | "available" | "unavailable";
  onFilterChange: (filter: "all" | "available" | "unavailable") => void;
  lastUpdated?: Date;
  isRefetching?: boolean;
}

export function YardTabContent({
  trucks,
  token,
  deleteTruck,
  updateTruck,
  updateEntryDirection,
  updateLicensePlate,
  availabilityFilter,
  onFilterChange,
  lastUpdated,
  isRefetching = false,
}: YardTabContentProps): React.JSX.Element {
  if (trucks.length === 0) {
    return <NoEntries />;
  }

  return (
    <>
      <StatCards
        trucks={trucks}
        onFilterChange={onFilterChange}
        currentFilter={availabilityFilter}
        lastUpdated={lastUpdated}
        isRefetching={isRefetching}
      />
      <VehicleTable
        trucks={trucks}
        index={0}
        token={token}
        deleteTruck={deleteTruck}
        updateTruck={updateTruck}
        updateEntryDirection={updateEntryDirection}
        updateLicensePlate={updateLicensePlate}
        availabilityFilter={availabilityFilter}
      />
    </>
  );
}
